import styled, { css } from 'styled-components';
import { EventTypeProcess } from '../../../types/ViewModel/EventTypeProcess';
import { EventTypeProcessInstance } from '../../../types/ViewModel/EventTypeProcessInstance';
import theme from 'src/theme';

export interface IButtonProps {
    isSelected?: boolean;
    notShowArrow?: boolean;
    onClick?: (prc: EventTypeProcess, prcInst: EventTypeProcessInstance | null) => void;
}

export const Icon = styled.i`
    color: red;
`;

export const StyledButton = styled.button<IButtonProps>`
    background: #00aeef;
    border: 1px solid #00aeef;
    border-right: 0;
    color: #fff;
    padding: 12px 8px;
    font-size: 0.8rem;
    margin: 0 0 2px;
    outline: 0;
    cursor: pointer;
    border-radius: 0;
    position: relative;

    &.list-item {
        border: 0;
        background: #f4f4f4;
        text-align: left;
        color: #04265a;
        padding: 0.5rem 1rem 0.5rem 2rem;
        line-height: 1rem;
        box-shadow: 0 5px 5px -3px #ddd;
        border-bottom: 1px solid #ddd;
        &:hover {
            background: #eee;
        }
        ${({ isSelected }) =>
            isSelected &&
            css`
                background: ${theme.legacyColors.selectedBackground} !important;
                color: ${theme.legacyColors.selectedColor} !important;
                border-bottom: 1px solid ${theme.legacyColors.selectedBorder} !important;
                .event-icon svg {
                    fill: ${theme.legacyColors.selectedColor} !important;
                }
            `}
        ${({ notShowArrow }) =>
            notShowArrow &&
            css`
                background: #fff;
            `}
      ${({ notShowArrow }) =>
            !notShowArrow &&
            css`
                border: 1px solid #c2cbae;

                .right-arrow-icon {
                    position: absolute;
                    right: 20px;
                    top: 30%;
                    display: block;
                    &.down-arrow-icon {
                        transform: rotate(90deg);
                    }
                }
            `}
    }

    .event-icon {
        position: absolute;
        left: 18px;
        top: 20%;
        width: 1.15rem;
        height: 18px;
        svg {
            fill: #04265a;
            width: 100%;
        }
    }

    .event-text {
        position: relative;
        left: 10px;
    }

    .right-arrow-icon {
        position: absolute;
        left: 5px;
        top: 30%;
        display: none;
    }

    .edit-icon {
        position: absolute;
        top: calc(50% - 8px);
        right: 5px;
        border-radius: 50%;
        width: 15px;
        height: 15px;
        font-size: 1rem;
    }

    .required-icon {
        margin: 0 0 4px 6px;
        font-size: 0.5rem;
    }
`;
